import React from 'react';

interface SkeletonProps {
  className?: string;
  width?: string;
  height?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '', width, height }) => {
  return (
    <>
      <style>{`
        @keyframes shine {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        .skeleton-shine {
          background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.08) 0%,
            rgba(0, 0, 0, 0.15) 50%,
            rgba(0, 0, 0, 0.08) 100%
          );
          background-size: 2000px 100%;
          animation: shine 2s linear infinite;
        }
      `}</style>
      <div 
        className={`rounded ${className}`}
        style={{ width, height }}
      >
        <div className="skeleton-shine w-full h-full rounded" style={{ width, height }} />
      </div>
    </>
  );
};

export default Skeleton;

